export const CONFIG = {
  repoOwner: "iamvany30",
  repoName: "etc.app",
  fallbackData: {
    name: "итд.app",
    description: "Социальная сеть нового поколения. Делитесь моментами, музыкой и мыслями.",
    authorName: "iamvany",
    repository: "https://github.com/iamvany30/etc.app"
  }
};